import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { Router } from '@angular/router';
import { AdoptionService } from '../../services/adoption.service';
import { DoctorService } from '../../services/doctor.service';
import { OtpconfirmationComponent } from '../../otpconfirmation/otpconfirmation.component';
import { MatDialog, MatDialogRef } from '@angular/material';
@Component({
  selector: 'app-addoptionmain',
  templateUrl: './addoptionmain.component.html',
  styleUrls: ['./addoptionmain.component.css']
})
export class AddoptionmainComponent implements OnInit {
  userStatus: number;
  adoption = [{ id: 2, type: 'Dog', img: 'dog.png' }, { id: 3, type: 'Cat', img: 'cat.png' }
  , {id: 4 , type: 'Bird' , img: 'bird.png'} , {id: 5 , type: 'Small Animal', img: 'smallanimal.png'}];
  uid: any;
  loading = false;
  myadoption: any;
  adoptiondoc = [];
  mydata: any;
  user_name: any;
  umobile: any;
  constructor(public commonService: CommonService, private router: Router,
    private adoptionService: AdoptionService, private doctorService: DoctorService, public dialog: MatDialog) {
      window.scrollTo(0, 0);
      this.userStatus = this.commonService.checkUserStatus();
      if (this.userStatus === 1) {
        const udata = this.commonService.getUserDataLocally();
        this.uid = udata.uid;
        this.user_name = udata.uname;
        this.umobile = udata.umobile
        this.getMydata();
      }
   }
   getMydata() {
    this.loading = true;
      this.doctorService.getCommentedUserDetail(this.uid)
      .subscribe(
      (x) => {
        this.mydata = x;
        this.loading = false;
      });
   }
  ngOnInit() {
    this.getMyAdoptionhistory();
  }
  goToAdoptionForm() {
    const flag = 4;
    this.commonService.setActivatepath(flag);
    this.router.navigate(['/petadoption/formfillup']);
  }
  getMyAdoptionhistory() {
    this.loading = true;
    this.adoptionService.getMyAdoptionPendingList(this.uid)
    .subscribe(
      (x) => {
        this.loading = false;
        this.myadoption = x;
        if (this.myadoption && this.myadoption.length > 0 ) {
          let i = this.myadoption.length;
          while (i -- ) {
            if (this.myadoption[i].adoptionstatus === 'published' || this.myadoption[i].adoptionstatus === 'adopted' ) {
              this.myadoption.splice(i, 1);
            }
          }
          let n = this.myadoption.length;
          while (n --) {
            if (this.myadoption[n].vaccination === 'no' && this.myadoption[n].kci === 'no' ) {
              this.myadoption.splice(n, 1);
            }
          }
          this.serchAdoptionForpendingList();
        }
      });
  }
  serchAdoptionForpendingList() {
   
    for (let i = 0; i < this.myadoption.length ; i++ ) {
      this.adoptionService.getDocumentForParticularAdoption(this.myadoption[i].id)
      .subscribe(
        (x) => {
          if (x && x.length === 0) {
            this.adoptiondoc.push(this.myadoption[i].id);
          }
        });
     }
  }
  managePost(id, status) {
    if (status === 'pending_otp') {
      if (this.mydata.verified === 'v') {
        this.adoptionService.updateAdoptiondata(id, 'waiting For Verification')
        .subscribe(
          (x) => {
            this.loading = false;
            this.router.navigate(['/petadoption/document updation pending/id']);
          });
       } else {
        this.otpConfirm(id);
      }
    } else {
      this.router.navigate(['/petadoption/document updation pending/' + id]);
    }
  }
  otpConfirm(id) {
      const otp = this.getRandomArbitrary(1000, 9000);
      this.loading = true;
      this.commonService.createOtp(this.uid, otp)
      .subscribe(
         (x) => {
           this.loading = false;
          this.commonService.sendOtp(this.user_name, this.umobile, otp);
          this.confirmation(id);
        });
  }

  getRandomArbitrary(min, max) {
    const num = min + Math.random() * max;
   return Math.trunc(num);
  }
confirmation(id) {
  const dialogRef = this.dialog.open(OtpconfirmationComponent , {
    width: '400px',
    height: '400px',
    data: {}
  });
  dialogRef.afterClosed().subscribe(result => {
    if (result === 1) {
      this.loading = true;
      this.adoptionService.updateAdoptiondata(id, 'waiting For Verification')
      .subscribe(
        (x) => {
          this.loading = false;
          this.router.navigate(['/petadoption/document updation pending/id']);
        });
    }
  });
 }
}
